import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderUtilService } from '@app/lib/b2b-services/loader/loader-util.service';

@Component({
  selector: 'b2b-ripple-loader',
  templateUrl: './ripple-loader.component.html',
  styleUrls: ['./ripple-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RippleLoaderComponent implements OnInit {
  isLoading$: Subject<boolean>;
  message$: Subject<string>;

  constructor(private loaderService: LoaderUtilService) {
    this.isLoading$ = this.loaderService.isLoading;
    this.message$ = this.loaderService.message;
  }

  ngOnInit(): void {}

  onClick() {
    if (this.loaderService?.configOptions?.backdrop) {
      this.loaderService.hide();
    }
  }
}
